import { render, staticRenderFns } from "./window-item-secondary.vue?vue&type=template&id=19856f5d&scoped=true&"
import script from "./window-item-secondary.vue?vue&type=script&lang=js&"
export * from "./window-item-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19856f5d",
  null
  
)

export default component.exports